import React from "react";
import { ComposableMap, Geographies, Geography } from "react-simple-maps";

export default function MapCard({
  geojson,
  currentState,
  questionNumber,
  loading,
  mapScale,
}) {
  return (
    <div className="map-card">
      <div className="map-card-header">
        <span>Map of India</span>
        <span>
          Question:{" "}
          <strong style={{ color: "#e5e7eb" }}>{questionNumber}</strong>
        </span>
      </div>

      <div className="map-inner">
        {loading ? (
          <div className="map-loading">Loading map…</div>
        ) : (
          <div className="map-center-wrapper">
            <ComposableMap
              projection="geoMercator"
              projectionConfig={{
                center: [82.5, 22.5],
                scale: mapScale,
              }}
              style={{ width: "100%", height: "100%" }}
            >
              <Geographies geography={geojson}>
                {({ geographies }) =>
                  geographies.map((geo) => {
                    const p = geo.properties || {};
                    const stateName =
                      p.State_Name ||
                      p.STATE_NAME ||
                      p.NAME_1 ||
                      p.ST_NM ||
                      p.name ||
                      p.st_nm;

                    const isTarget =
                      currentState && stateName === currentState.name;

                    return (
                      <Geography
                        key={geo.rsmKey}
                        geography={geo}
                        style={{
                          default: {
                            fill: isTarget
                              ? "#f97316"
                              : "rgba(148,163,184,0.35)",
                            outline: "none",
                            stroke: "#1f2937",
                            strokeWidth: 0.7,
                          },
                          hover: {
                            fill: isTarget
                              ? "#fb923c"
                              : "rgba(209,213,219,0.9)",
                            outline: "none",
                          },
                          pressed: {
                            fill: isTarget ? "#fb923c" : "#e5e7eb",
                            outline: "none",
                          },
                        }}
                        className={isTarget ? "blink-state" : ""}
                      />
                    );
                  })
                }
              </Geographies>
            </ComposableMap>
          </div>
        )}
      </div>
    </div>
  );
}
